export default {
  namespaced: true,
  state: {
    dataList: []
  }
}
